<template>
  <div class="footer">
    <div class="copyright">
      <span>© {{ currentYear }} Amejpay. All rights reserved.</span>
    </div>
    <div class="divider"></div>
    <div class="privacy">
      <ul>
        <li>
          <router-link :to="{ name: 'pricacyPolicy' }"
            ><span>Privacy Policy</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'termAndCondition' }"
            ><span>Terms & Conditions</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'customerCare' }"
            ><span>Customer Care</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'faqNew' }"><span>FAQs</span></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",

  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
<style lang="scss">
@import "../../css/style.scss";
</style>
